module.exports = "<div class=\"view-container\">\r\n  <app-alert></app-alert>\r\n  <app-side-bar></app-side-bar>\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main